import React from 'react';
import { useNavigate } from 'react-router-dom';
import PlusIcon from '../components/PlusIcon';
import './WelcomePage.css';

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <h1 className="welcome-title">
          Starte und lege deine erste Immobilie an!
        </h1>
        <button
          className="welcome-button"
          onClick={() => navigate('/properties/new')}
        >
          <PlusIcon className="welcome-button-icon" />
          <span className="welcome-button-text">Neue Immobilie hinzufügen</span>
        </button>
      </div>
    </div>
  );
};

export default WelcomePage;
